import {type HttpEvent, type HttpInterceptorFn, HttpResponse} from '@angular/common/http';
import {map} from 'rxjs';
import {inject} from "@angular/core";
import {EnvironmentService} from "@services/environment.service";

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const environmentService = inject(EnvironmentService);
  let token: string | null = localStorage.getItem('tknStore');
  token = token && token.toString().trim() === 'null' ? null : token;

  let modifiedRequest = req.clone({
    headers: req.headers
      .set('Accept', 'application/json, text/plain, */*')
      .set('Content-Type', 'application/json')
      .set('client', environmentService.getNameMultiClient()),
  });

  if (token) {
    modifiedRequest = modifiedRequest.clone({headers: modifiedRequest.headers.set('token2X', token)});
  }

  return next(modifiedRequest).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // Solo se guarda si la respuesta trae token: antes escribia igual, asi
        // que cualquier 200 sin la cabecera dejaba el token en vacio y borraba
        // la sesion del cliente sin que se entere.
        const renewed = event.headers.get('token2X');
        if (event.status === 200 && renewed) {
          // El backend manda "token-expiration"; antes se leia
          // "tknStore-expiration", que es el nombre de la clave local y no el
          // del header. Como no existia, Number(null) daba 0 y el vencimiento
          // quedaba en el instante actual: el token nacia vencido.
          const ttl = Number(event.headers.get('token-expiration'));
          localStorage.setItem('tknStore', renewed);
          if (ttl > 0) {
            const timeExpiration: number = ttl + new Date().getTime();
            localStorage.setItem('tknStore-expiration', JSON.stringify(timeExpiration));
          }
        }
      }
      return event;
    })
  );
};
